import { ajax } from "@/assets/js/ajax";
export function getSubject(data) {     //案件主体列表
  return ajax({
    url: 'accuser/index',
    type: 'get',
    data: data
  })
}

export function accuserInfo(data) {     //原告详情
  return ajax({
    url: 'accuser/info',
    type: 'get',
    data: data
  })
}

export function accuserEdit(data) {     //原告修改
  return ajax({
    url: 'accuser/edit',
    type: 'post',
    data: data
  })
}

export function accuserAdd(data) {     //原告添加
  return ajax({
    url: 'accuser/add',
    type: 'post',
    data: data
  })
}
